<template>
    <layout :active="20" :title="true">
        <div class="content-body">
            <div class="container">
                <div class="row">
                    <div class="col-xl-3 col-md-4">
                        <div class="card settings_menu">
                            <div class="card-header">
                                <h4 class="card-title"><a @click="$router.push('/account')" class="mr-3"><i class="fas fa-arrow-circle-left"></i></a>Short Link</h4>
                            </div>
                            <div class="card-body">
                                <ul>
                                    <li class="nav-item" v-if="Access('products-productos-listado')">
                                        <router-link to="/shortlink-create" class="nav-link" :class="active === 31 && 'active'">
                                            <i class="fas fa-file-pdf mr-4"></i>
                                            <span>Crear URL corta</span>
                                        </router-link>
                                    </li>
                                    <li class="nav-item" v-if="Access('products-productos-listado')">
                                        <router-link to="/shortlink-list" class="nav-link" :class="active === 32 && 'active'">
                                            <i class="fas fa-spell-check mr-3"></i>
                                            <span>Listado de URLs</span>
                                        </router-link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-9 col-md-8">
                        <slot/>
                    </div>
                </div>
            </div>
        </div>
    </layout>
</template>

<script>
import Layout from "/src/layout/LayoutLoader.vue";
import {mapGetters} from "vuex";
import {store} from "/src/store";


export default {
    name: "SettingLayout",
    components: {
        Layout,
    },
    props: {
        active: Number,
    },
    computed: {
        ...mapGetters({
            whiteLabelInfo: 'whiteLabelInfo',
            AuthGetUserInfo: 'AuthGetUserInfo',
            Access: 'Access',
        })
    },
    data() {
        return {
        }
    }
};
</script>
